import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Opciones estáticas
export const APTITUDE_OPTIONS = ['Informática', 'Negocios', 'Emprendimiento', 'Otros..'];

export const monthsEs = [
  'ene',
  'feb',
  'mar',
  'abr',
  'may',
  'jun',
  'jul',
  'ago',
  'sep',
  'oct',
  'nov',
  'dic',
];

// Helper para formatear fechas
export const formatMonthYear = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(`${dateStr}T00:00:00`);
  return Number.isNaN(d.getTime()) ? dateStr : `${monthsEs[d.getMonth()]} ${d.getFullYear()}`;
};

// --- Estilos Reutilizables (Props) ---

export const secondaryButtonSx = {
  backgroundColor: '#eff2f5 !important',
  color: '#7b809a !important',
  textShadow: 'none !important',
  boxShadow: 'none !important',
  '&:hover': { backgroundColor: '#e0e0e0 !important' },
};

export const listChipSx = {
  mr: 0.5,
  my: 0.5,
  fontSize: '0.8rem',
  bgcolor: '#eff2f5',
  color: '#111827',
  border: '1px solid #e5e7eb',
};

export const commonInputProps = {
  fullWidth: true,
  variant: 'outlined',
  InputLabelProps: { shrink: true },
  sx: {
    '& .MuiOutlinedInput-root': { minHeight: '44px', padding: '0px' },
    '& .MuiInputBase-input': {
      height: '44px',
      padding: '0 14px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiOutlinedInput-root.MuiInputBase-multiline': {
      height: 'auto !important',
      minHeight: '44px',
      padding: '12px',
    },
    '& .MuiInputBase-multiline .MuiInputBase-input': {
      height: 'auto !important',
      padding: '0',
    },
  },
};

export const selectInputProps = {
  fullWidth: true,
  variant: 'outlined',
  select: true,
  InputLabelProps: { shrink: true },
  SelectProps: {
    IconComponent: ExpandMoreIcon,
    displayEmpty: true,
  },
  sx: {
    '& .MuiOutlinedInput-root': { minHeight: '44px' },
    '& .MuiSelect-select': {
      height: '44px !important',
      minHeight: '44px !important',
      padding: '0 48px 0 14px !important',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSelect-icon': {
      color: '#7b809a !important',
      right: '12px',
      position: 'absolute',
      top: 'calc(50% - 12px)',
      display: 'block !important',
      zIndex: 5,
    },
  },
};
